export enum FlightDetailActionsEnum {
  COPY_DETAILS = "COPY_DETAILS",
  EMAIL_DETAILS = "EMAIL_DETAILS",
}
